module.exports = __webpack_public_path__ + "static/media/roberttinga.73814f22.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/roberttinga.webp
// module id = 703
// module chunks = 0